type TabProps = {
    isActive: boolean
    onClick: () => void
    children: React.ReactNode
}

const Tab = (props: TabProps) => {
    const { isActive, onClick, children } = props

    return (
        <div
            onClick={() => onClick()}
            className={`flex pb-5 leading-5 text-brand-black font-medium cursor-pointer ${
                isActive ? 'border-b-4 border-brand-primary' : 'hover:border-b-4 hover:border-purple-light'
            }`}
        >
            {children}
        </div>
    )
}

export default Tab
